import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Returns a dashboard-relative redirect path when the target route requires
// account feature flags that are disabled for this merchant.
export function accountFeatureRouteRedirect(
  to,
  accountId,
  isFeatureEnabledOnAccount
) {
  if (!accountId) return null;

  const requiredFlags = new Set();
  const { meta: { featureFlag } = {} } = to;

  if (featureFlag) requiredFlags.add(featureFlag);
  if (to.path.includes('/settings/integrations')) {
    requiredFlags.add(FEATURE_FLAGS.INTEGRATIONS);
  }

  const blocked = [...requiredFlags].some(
    flag => !isFeatureEnabledOnAccount(accountId, flag)
  );

  return blocked ? `accounts/${accountId}/dashboard` : null;
}
